/* Individual customer-building page: fetches public detail by ?b=<handle>,
 * renders photos with a main-image switcher, story, specs, and share links. */
(function () {
  "use strict";
  var root = document.querySelector(".crb-bldg");
  if (!root) return;
  var API = (root.getAttribute("data-api-base") || "").replace(/\/+$/, "");
  var handle = new URLSearchParams(location.search).get("b") || "";

  var $ = function (id) { return document.getElementById(id); };

  function fail() {
    $("cb-loading").hidden = true;
    $("cb-missing").hidden = false;
  }
  if (!handle) return fail();

  fetch(API + "/api/share/public/building?handle=" + encodeURIComponent(handle))
    .then(function (r) { return r.json(); })
    .then(function (json) {
      if (!json.ok || !json.building) return fail();
      render(json.building);
    })
    .catch(fail);

  function render(b) {
    document.title = b.title + " | Cedar Rock Barns";
    $("cb-title").textContent = b.title;
    var place = [b.city, b.state].filter(Boolean).join(", ");
    $("cb-meta").textContent = [place, b.purchaseYear && "Cedar Rock Barns customer since " + b.purchaseYear]
      .filter(Boolean)
      .join(" · ");

    // Photos: big image + thumbnail switcher.
    var main = $("cb-main");
    var thumbs = $("cb-thumbs");
    if (b.photos.length) {
      main.hidden = false;
      var setMain = function (i) {
        main.src = b.photos[i].full;
        main.alt = b.title + " photo " + (i + 1);
        Array.prototype.forEach.call(thumbs.children, function (t, j) {
          t.setAttribute("data-active", j === i ? "true" : "false");
        });
      };
      b.photos.forEach(function (p, i) {
        var t = document.createElement("img");
        t.src = p.thumb;
        t.alt = "View photo " + (i + 1);
        t.loading = "lazy";
        t.setAttribute("role", "listitem");
        t.tabIndex = 0;
        t.addEventListener("click", function () { setMain(i); });
        t.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setMain(i); } });
        thumbs.appendChild(t);
      });
      setMain(0);
      if (b.photos.length < 2) thumbs.hidden = true;
    }

    // Videos.
    var vids = $("cb-videos");
    b.videos.forEach(function (v) {
      var el = document.createElement("video");
      el.controls = true;
      el.preload = "metadata";
      el.src = v.url;
      vids.appendChild(el);
    });

    $("cb-use").textContent = b.use || "";
    $("cb-story").textContent = b.story || "";
    if (!b.story) $("cb-story-h").textContent = "How they use it";

    var specs = $("cb-specs");
    [["Size", b.size], ["Style", b.style], ["Siding", b.siding], ["Colors", b.colors], ["Year purchased", b.purchaseYear]]
      .filter(function (row) { return row[1]; })
      .forEach(function (row) {
        var dt = document.createElement("dt");
        dt.textContent = row[0];
        var dd = document.createElement("dd");
        dd.textContent = row[1];
        specs.appendChild(dt);
        specs.appendChild(dd);
      });

    // Share links. Prefer the share URL (server-rendered tags, so Facebook,
    // iMessage, and texts show this building's own photo in the preview).
    var url = b.shareUrl || location.origin + location.pathname + "?b=" + encodeURIComponent(b.handle);
    var text = "Check out " + b.title + " on Cedar Rock Barns!";
    var fb = $("cb-fb");
    fb.href = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
    fb.addEventListener("click", function (e) {
      // Open Facebook's share composer in a popup. A plain link click can lose
      // the share intent behind Facebook's login redirect or the mobile app;
      // on devices with a native share sheet, that sheet is the most reliable
      // way to reach the Facebook app with the link attached.
      e.preventDefault();
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
        navigator.share({ title: b.title, text: text, url: url }).catch(function () { /* user closed the sheet */ });
      } else {
        var w = window.open(fb.href, "crbfbshare", "width=626,height=460,noopener");
        if (!w) window.open(fb.href, "_blank");
      }
      if (window.dataLayer) window.dataLayer.push({ event: "customer_building_share_clicked", method: "facebook" });
    });
    $("cb-txt").href = "sms:?&body=" + encodeURIComponent(text + " " + url);
    $("cb-em").href = "mailto:?subject=" + encodeURIComponent(text) + "&body=" + encodeURIComponent(url);
    $("cb-copy").addEventListener("click", function () {
      navigator.clipboard.writeText(url).then(function () {
        $("cb-copied").textContent = "Link copied! Paste it anywhere to share.";
      });
      if (window.dataLayer) window.dataLayer.push({ event: "customer_building_share_clicked", method: "copy" });
    });
    // Native share sheet button (phones/tablets get the system sheet where
    // Facebook, Messages, and Messenger all attach the link correctly).
    if (navigator.share) {
      var shareBtn = document.createElement("button");
      shareBtn.type = "button";
      shareBtn.className = "crb-bldg__btn crb-bldg__btn--primary";
      shareBtn.textContent = "Share...";
      shareBtn.addEventListener("click", function () {
        navigator.share({ title: b.title, text: text, url: url }).catch(function () { /* closed */ });
        if (window.dataLayer) window.dataLayer.push({ event: "customer_building_share_clicked", method: "native" });
      });
      $("cb-copy").parentNode.insertBefore(shareBtn, $("cb-copy"));
    }

    $("cb-loading").hidden = true;
    $("cb-article").hidden = false;
    if (window.dataLayer) window.dataLayer.push({ event: "customer_building_page_view", building: b.handle });

    initVoting(b);
  }

  /* ---------- voting ---------- */

  function initVoting(b) {
    fetch(API + "/api/share/public/contest?handle=" + encodeURIComponent(b.handle))
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (!json.ok) return;
        if (json.active) renderVoteBox(b, json);
        else if (json.ended) {
          var box = $("cb-vote-ended");
          $("cb-vote-ended-text").textContent =
            "Voting in the " + json.ended.name + " contest has ended." +
            (json.ended.votes != null ? " This building received " + json.ended.votes + " vote" + (json.ended.votes === 1 ? "" : "s") + ". Thanks to everyone who voted!" : " Thanks to everyone who voted!");
          box.hidden = false;
        }
      })
      .catch(function () { /* voting box just stays hidden */ });
  }

  function renderVoteBox(b, info) {
    var box = $("cb-vote");
    var msg = $("cb-vote-msg");
    var voteId = null;
    $("cb-vote-contest").textContent = info.contest.name;
    updateStatus(info.votes);
    if (info.contest.rulesUrl) {
      $("cb-vote-rules").hidden = false;
      $("cb-vote-rules-link").href = info.contest.rulesUrl;
    }
    box.hidden = false;

    function updateStatus(votes) {
      var closes = new Date(info.contest.closesAt);
      var parts = [];
      if (votes != null) parts.push(votes + " vote" + (votes === 1 ? "" : "s") + " so far");
      if (!isNaN(+closes)) parts.push("voting closes " + closes.toLocaleDateString("en-US", { month: "long", day: "numeric" }));
      $("cb-vote-status").textContent = parts.join(" · ");
    }
    function say(text, tone) {
      msg.textContent = text;
      msg.setAttribute("data-tone", tone || "");
    }

    $("cb-vote-start").addEventListener("click", function () {
      var email = $("cb-vote-email").value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return say("Please enter a valid email address.", "bad");
      this.disabled = true;
      say("Sending your code...");
      var btn = this;
      fetch(API + "/api/share/vote/start", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ handle: b.handle, email: email, website: $("cb-vote-hp").value })
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          btn.disabled = false;
          if (!json.ok) return say(json.error || "Something went wrong. Please try again.", "bad");
          voteId = json.voteId;
          $("cb-vote-step1").hidden = true;
          $("cb-vote-step2").hidden = false;
          $("cb-vote-code").focus();
          say("Code sent to " + email + "!", "good");
          if (window.dataLayer) window.dataLayer.push({ event: "contest_vote_started" });
        })
        .catch(function () { btn.disabled = false; say("We couldn't reach the server. Please try again.", "bad"); });
    });

    $("cb-vote-confirm").addEventListener("click", function () {
      var code = $("cb-vote-code").value.replace(/\D/g, "");
      if (code.length !== 6) return say("Enter the 6-digit code from your email.", "bad");
      this.disabled = true;
      var btn = this;
      fetch(API + "/api/share/vote/confirm", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ voteId: voteId, code: code })
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          btn.disabled = false;
          if (!json.ok) {
            say(json.error || "That didn't work. Please try again.", "bad");
            if (json.expired) {
              $("cb-vote-step2").hidden = true;
              $("cb-vote-step1").hidden = false;
            }
            return;
          }
          $("cb-vote-step2").hidden = true;
          say("🎉 Your vote is in! Thanks for supporting this building.", "good");
          if (json.votes != null) updateStatus(json.votes);
          if (window.dataLayer) window.dataLayer.push({ event: "contest_vote_verified" });
        })
        .catch(function () { btn.disabled = false; say("We couldn't reach the server. Please try again.", "bad"); });
    });
  }
})();
